import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { IGetPantalla, IGetPantallasResponse, IPantalla } from '../../interfaces/response/IGetPantallasResponse';
import { map } from 'rxjs/operators';
import { StatusService } from '../../services/status/status.service';

export enum Pantallas {
    "Index" = 1,
    "coverageList" = 2,
    "carrusel" = 3,
    "perfilUsuario" = 4,
    "roboYPerdida" = 5,
    "daniosAcc" = 6,
    "EmailTemplate" = 7,
    "DetCobDaños" = 8,
    "DepreBici" = 9,
    "AccesoMejoras" = 10,
    "SALES22" = 11,
    "MejorasModif" = 12,
    "ADMIN341" = 13,
}

@Injectable({
    providedIn: 'root'
})
export class PantallasService {

  baseUrl = `${environment.baseUrl}`;
    apiUrl = `${environment.ApiProducto}`;
    url: string;

    constructor(
        private http: HttpClient,
        private statusService: StatusService
    ) {
        this.url = this.baseUrl + this.apiUrl;
    }

    /**
     * Get an array of elements that compose the screen
     * @param alias The screen's alias
     * @returns Array of element for the screen filtered by language
     */
    getPantallas(alias: string): Observable<IGetPantalla> {
      return this.http.get<IGetPantallasResponse>(`${this.baseUrl}${this.apiUrl}/GetPantallasbyAlias/${alias}`).pipe(
            map(resp => this.get_pantallas(resp))
        );
    }

    /**
     * Get an array of elements that compose the screen filtered by several parameters
     * @param idPantalla The screen ID
     * @param idProducto The product ID
     * @param idCategoria The category ID
     * @param idFamilia The family ID
     * @param idGrupo The group ID
     * @param idSeccion The section ID
     * @returns  Array of element for the screen filtered by several parameters
     */
  getPantallasFiltrando(idScreen?: number, idProducto?: number, idCategoria?: number, idFamilia?: number, idGrupo?: number, idSeccion?: number): Observable<IGetPantalla> {
        //if(!idProducto) idProducto = this.statusService.getCurrentObject().categorySelected?.idProducto;
        const query_params = { idProducto: idProducto };
        const params = this.add_params(query_params);
      return this.http.get<IGetPantallasResponse>(`${this.baseUrl}${this.apiUrl}/GetScreensFilters/${idScreen}/Coberturas`, params).pipe(
            map(resp => this.get_pantallas(resp))
        );
    }

    /**
     * Return an object with the params defined
     * @param params The params to be inserted in the query
     * @returns An object to be passed to the the request's params
     */
    private add_params(params: any): { params: HttpParams } {
        return {
            params: new HttpParams({
                fromObject: {
                    ...params
                }
            })
        };
    }

    /**
     * Get Pantallas array from a IGetPantallasResponse response
     * @param resp The response of the endpoint
     * @returns Array of IPantalla
     */
    private get_pantallas(resp: IGetPantallasResponse): IGetPantalla {
        if (!resp.succeeded) return [];

        const data = resp.data;
        Object.values(data).forEach((pantallas: IPantalla[]) => {
            pantallas.forEach(pantalla => {
                if (pantalla.imagen) {
                    const image_path = this.get_full_image_path(pantalla.imagen);
                    pantalla.imagen = this.sanitize_path(image_path);                
                }
            })            
        });
        return data;
    }

    /**
     * Determine the assets path to find the image
     * @param image_path The image path inside the assets
     * @returns The path to get the image
     */
    private get_full_image_path(image_path: string): string {
        let image = image_path;
        if(image_path.includes("/")) image = this.get_assets_path("img", image_path);
        return image;
    }

    /**
     * Determie the asset path given a subfolder and a path
     * @param folder the subfolder in the assets
     * @param file_path the file path to find the asset
     * @returns the full assets path to the asset
     */
    private get_assets_path(asset_subfolder: string, file_path: string): string {
        return `/assets/${asset_subfolder}/${file_path}`;
    }

    /**
     * Sanitize the path string to avoid directory navitation issues
     * @param path The path to sanitize
     * @returns The sanitized path to use without navitation issues
     */
    private sanitize_path(path: string): string {
        return path.replace("//", "/");
    }

}
